import {
  SET_ORDER_DETAIL,
  SET_POOL_GRID_DATA,
  SET_PURCHASE_TYPE_DROPDOWN,
  SET_REGISTERED_DROPDOWN,
  SET_ORDER_TYPE_DROPDOWN,
  SET_CLIENT_CODE_DROPDOWN,
  SET_REASON_CODE_DROPDOWN,
  SET_CAPEX_DROPDOWN,
  SET_ASSIGNTO_DROPDOWN,
  SET_VENDOR_DETAILS,
  SET_PURACHSE_ORDER_STEPPER_DATA,
  SET_ERROR,
  SET_CHANGE_LOGS,
  SET_PURACHSE_ORDER_STEPPER_INFO,
  UPDATE_FLEET_STATUS_ORDER,
  SET_FLEET_ORDER_DETAIL,
  SET_PO_EQ_CLASS_CODE_DROPDOWN,
} from "./types";
const initialState = {
  orderDetail: {
    poDetails: [],
  },
  poolGridData: [],
  purchaseType: [],
  registered: [],
  orderType: [],
  clientCode: [],
  reasonCode: [],
  capexType: [],
  assignTo: [],
  fleetRequestDetailData: [],
  purchaseOrderStepperData: [],
  vendorDetails: {},
  error: undefined,
  changeLogs: {},
  eqClassCodeDropdown: [],
};
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ORDER_DETAIL:
      return {
        ...state,
        orderDetail: action.value,
      };
    case SET_FLEET_ORDER_DETAIL:
      return {
        ...state,
        fleetOrderDetail: action.value,
      };
    case UPDATE_FLEET_STATUS_ORDER:
      return {
        ...state,
        orderDetail: {
          ...state.orderDetail,
          poDetails: state.orderDetail.poDetails
            ? [
                ...state.orderDetail.poDetails.map((x: any) => {
                  if (x.id === action.payload.fleetDetailId) {
                    return {
                      ...x,
                      ...action.payload,
                      fleetDetailId: undefined,
                    };
                  }
                  return x;
                }),
              ]
            : [],
        },
      };
    case SET_POOL_GRID_DATA:
      return {
        ...state,
        poolGridData: action.payload,
      };
    case SET_PURCHASE_TYPE_DROPDOWN:
      return {
        ...state,
        purchaseType: action.payload,
      };
    case SET_REGISTERED_DROPDOWN:
      return {
        ...state,
        registered: action.payload,
      };
    case SET_ORDER_TYPE_DROPDOWN:
      return {
        ...state,
        orderType: action.payload,
      };
    case SET_CLIENT_CODE_DROPDOWN:
      return {
        ...state,
        clientCode: action.payload,
      };
    case SET_REASON_CODE_DROPDOWN:
      return {
        ...state,
        reasonCode: action.payload,
      };
    case SET_CAPEX_DROPDOWN:
      return {
        ...state,
        capexType: action.payload,
      };
    case SET_ASSIGNTO_DROPDOWN:
      return {
        ...state,
        assignTo: action.payload,
      };
    case SET_VENDOR_DETAILS:
      return {
        ...state,
        vendorDetails: action.payload,
      };
    case SET_PURACHSE_ORDER_STEPPER_DATA:
      return {
        ...state,
        purchaseOrderStepperData: [
          ...state.purchaseOrderStepperData.map((item: any) => {
            if (item?.itemNumber === action.payload?.itemNumber) {
              return action.payload;
            }
            return item;
          }),
        ],
      };
    case SET_PURACHSE_ORDER_STEPPER_INFO:
      return {
        ...state,
        purchaseOrderStepperData: [...action.payload],
      };
    case SET_CHANGE_LOGS:
      return {
        ...state,
        changeLogs: { ...state.changeLogs, ...action.payload },
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_PO_EQ_CLASS_CODE_DROPDOWN:
      return {
        ...state,
        eqClassCodeDropdown: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
